// @flow
import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import getIn from '@mzvonar/getin';
import makeStyles from "@material-ui/core/styles/makeStyles";
import classnames from 'classnames';
import type { Car, Plane } from '../../types';
import { isValue } from '../../utils';
import Dot from '../ui/Dot';
import type { Props as DotProps } from '../ui/Dot';

const useStyles = makeStyles(theme => ({
    flexbox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    flexboxGap: {
        paddingRight: theme.spacing(12)
    }
}));

const NA = (
    <FormattedMessage
        id="general.na"
        defaultMessage="N/A"
    />
);

type Props = $ReadOnly<{
    target: Car | Plane,
    cells: $ReadOnlyArray<$ReadOnly<{
        id?: string | $ReadOnlyArray<string>,
        value?: any,
        label: Node,
        parser?: (value: any) => any,
        valueColor?: $PropertyType<DotProps, 'color'>
    }>>
}>;

function Row({ target, cells }: Props) {
    const classes = useStyles();

    return (
        <TableRow>
            {cells.map((cell, index) => {
                let value = typeof cell.value !== 'undefined' ? cell.value : cell.id && getIn(target, cell.id);
                value = cell.parser ? cell.parser(value) : value;
                const hasValue = isValue(value);

                return (
                    <React.Fragment key={index}>
                        <TableCell scope="row" padding="none">
                            <div className={classnames(classes.flexbox, {
                                [classes.flexboxGap]: !index && cells.length > 1
                            })}>
                                <span>
                                    <Dot color={hasValue ? cell.valueColor || 'green' : 'gray'} />
                                    {cell.label}
                                </span>
                                <span>{hasValue ? value : NA}</span>
                            </div>
                        </TableCell>
                    </React.Fragment>
                );
            })}
        </TableRow>
    );
}

export default Row;